import React from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import {
  AccountReceivableSearchCriteria,
  RestAccountReceivableListRequest,
  RestPageListBean,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmptyArray, isEmptyString } from "../gui_components/Util.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { AccountReceivableService } from "../services/AccountReceivableService.js";
export class CheckLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name, customerCode) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.customerCode = customerCode;
    let resetCriteria = new AccountReceivableSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new AccountReceivableSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let checkLookupCriteria = new AccountReceivableSearchCriteria();
    checkLookupCriteria.companyCode = this.companyCode;
    checkLookupCriteria.customerCode = this.customerCode;
    let lookupCriteriaView = CheckLookupCriteriaHandler(
      companyCode,
      checkLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      checkLookupCriteria,
      lookupCriteriaView
      //null
    );
    ModuleUtils.getARStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "checkNumber", 0, true); //1
    this.addColumnDefinition("AR", "code", 0, false); //2
    this.addColumnDefinition("AR Date", "accountReceivableDate", 0, false); //2
    this.addColumnDefinition("CustomerCode", "customerCode", 0, false); //3
    this.addColumnDefinition("CustomerName", "customerName", 0, false); //3
    this.addColumnDefinition("CheckAmt", "checkAmount", 0, false); //3
    this.addColumnDefinition("Status", "accountReceivableStatus", 0, false); //3
  }
  loadCheckList = (lookup_dialog, pageNumber, searchCriteria) => {
    let criteria = new AccountReceivableSearchCriteria(); //To be fetched from CriteriaHandler
    criteria.companyCode = this.companyCode;
    criteria.customerCode = this.customerCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      criteria.checkNumber = searchCriteria.checkNumber;
    }
    let pageList = new RestPageListBean();
    pageList.pageSize = 150; //TODO --> Fetch from Config
    pageList.currentPage = pageNumber;
    // pageList.pageNumber = pageNumber;
    let requestInput = new RestAccountReceivableListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    AccountReceivableService.getAccountReceivablePageList(
      requestInput,
      (response) => this.loadCheckPageResponse(response, lookup_dialog),
      this.loadCheckPageError
    );
  };
  loadCheckPageResponse = (response, lookup_dialog) => {
    let checkList = [];
    let filterCheckList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.accountReceivablePageList != null &&
      response.data.accountReceivablePageList.accountReceivables !== null
    ) {
      checkList = response.data.accountReceivablePageList.accountReceivables;
      totalCount = response.data.accountReceivablePageList.totalCount;
      currentPageNumber = response.data.accountReceivablePageList.currentPage;
      pageSize = response.data.accountReceivablePageList.pageSize;
      checkList.map((ln) => {
        if (
          ln.accountReceivableStatus == "P" ||
          ln.accountReceivableStatus == "F"
        ) {
          if (
            ln.checkAmount != null &&
            ln.checkAmount != 0 &&
            ln.checkAmount > 0
          ) {
            ln.accountReceivableStatus = ModuleUtils.getARStatusCaption(
              ln.accountReceivableStatus
            );
            filterCheckList.push(ln);
          }
        }
      });
    }
    let lookup_result_details = new LookupResultDetails();
    this.lookupdata = filterCheckList;
    lookup_result_details.pageData = this.lookupdata;
    let total_count = 0;
    if (!isEmptyArray(filterCheckList)) {
      total_count = filterCheckList.length;
    }
    lookup_result_details.totalRecordsCount = total_count;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadCheckPageError = (error) => {
    ShowError(error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.checkNumber)) {
      if (!isEmptyString(filterText)) {
        search.checkNumber = filterText;
        this.searchCriteria = new AccountReceivableSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadCheckList(lookup_dialog, pageNumber, search);
    }
  }
}
const CheckLookupCriteriaHandler = (companyCode, checkLookupCriteria) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new AccountReceivableSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new AccountReceivableSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>Customer#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="customerCode"
                  name="customerCode"
                  onChange={this.onChange}
                  value={searchCriteria.customerCode}
                />
              </Col>
            </Row>
            <Row className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
